import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TempleBuddhistIcon(props: IconProps) {
    return <Icon {...props} iconKey={"temple_buddhist"}/>
}
